import { Link } from 'react-router-dom';

interface CategoryCardProps {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
  color: string;
}

export default function CategoryCard({
  slug,
  name,
  icon,
  description,
  count,
  color,
}: CategoryCardProps) {
  return (
    <Link
      to={`/category/${slug}`}
      className="group block bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${color}`}>
        <i className={`${icon} text-xl`}></i>
      </div>
      <div className="flex items-center gap-2 mb-2">
        <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
          {name}
        </h3>
        <span className="text-xs text-foreground-500 whitespace-nowrap">({count}部)</span>
      </div>
      <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
        {description}
      </p>
    </Link>
  );
}